import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InduccionEstado } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { InduccionResultadoBusquedaModel } from 'src/app/models/induccion/InduccionResultadoBusquedaModel';
import { InduccionResultadosModel } from 'src/app/models/induccion/InduccionResultadoModel';
import { IFilterInduccionPorVencerModel } from 'src/app/models/interfaces/induccion/IFilterInduccionPorVencerModel';
import { IFilterInduccionModel } from 'src/app/models/interfaces/induccion/IFilterInduccionModel';
import { IInduccionProgramarModel, IInduccionReprogramarModel } from 'src/app/models/interfaces/induccion/IInduccionModel';
import { IInduccionResultadoBusquedaModel } from 'src/app/models/queries/inducciones/interfaces/IInduccionResultadoBusquedaModel';
import { environment } from 'src/environments/environment';
import { PersonaInduccionResultadoModel } from 'src/app/models/induccion/PersonaInduccionResultadoModel';
import { FilterInduccionesPorPersonaModel } from 'src/app/models/induccion/FilterInduccionesPorPersonaModel';

@Injectable({
  providedIn: 'root'
})
export class InduccionService {
  private configUrl = [environment.apiGatewayUrl, 'inducciones'].join('/');

  constructor(
    private http: HttpClient,
    private datepipe: DatePipe
  ) { }

  getList(
    model: IFilterInduccionModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<IInduccionResultadoBusquedaModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigo=${model.codigoSolicitud}`);
    }

    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaInicioInduccion){
      queryParams.push(`fechaInicioInduccion=${this.datepipe.transform(model.fechaInicioInduccion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinInduccion){
      queryParams.push(`fechaFinInduccion=${this.datepipe.transform(model.fechaFinInduccion, 'yyyy-MM-dd')}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }
    if(model.sedes.length > 0)
      queryParams.push(`sedes=${model.sedes.join(',')}`);

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    fechaInicioInduccion: Date;
    fechaFinInduccion: Date;

    if(model.idEstado !== InduccionEstado.EMPTY){
      queryParams.push(`estados=${model.idEstado}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    // if(model.idSede > 0){
    //   queryParams.push(`idSede=${model.idSede}`);
    // }

    return this.http.get<SearchResultModel<InduccionResultadoBusquedaModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  getListToExport(
    model: IFilterInduccionModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigo=${model.codigoSolicitud}`);
    }

    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaInicioInduccion){
      queryParams.push(`fechaInicioInduccion=${this.datepipe.transform(model.fechaInicioInduccion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinInduccion){
      queryParams.push(`fechaFinInduccion=${this.datepipe.transform(model.fechaFinInduccion, 'yyyy-MM-dd')}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if(model.sedes.length > 0)
      queryParams.push(`sedes=${model.sedes.join(',')}`);

    fechaInicioInduccion: Date;
    fechaFinInduccion: Date;

    if(model.idEstado !== InduccionEstado.EMPTY){
      queryParams.push(`estados=${model.idEstado}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    // if(model.idSede > 0){
    //   queryParams.push(`idSede=${model.idSede}`);
    // }

    return this.http.get(
      `${this.configUrl}/exportar/?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  getListToContratistaExport(
    model: IFilterInduccionModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigo=${model.codigoSolicitud}`);
    }

    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if(model.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(model.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(model.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaInicioInduccion){
      queryParams.push(`fechaInicioInduccion=${this.datepipe.transform(model.fechaInicioInduccion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinInduccion){
      queryParams.push(`fechaFinInduccion=${this.datepipe.transform(model.fechaFinInduccion, 'yyyy-MM-dd')}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }
    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }
    fechaInicioInduccion: Date;
    fechaFinInduccion: Date;

    if(model.idEstado !== InduccionEstado.EMPTY){
      queryParams.push(`estados=${model.idEstado}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(
      `${this.configUrl}/contratista/exportar/?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  getListPorVencer(
    model: IFilterInduccionPorVencerModel
  ): Observable<SearchResultModel<IInduccionResultadoBusquedaModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicio=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFin=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<IInduccionResultadoBusquedaModel[]>>(
      `${this.configUrl}/por-vencer/?${queryParams.join('&')}`
    );
  }

  getListPorVencerToExport(
    model: IFilterInduccionPorVencerModel
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicio=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFin=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(
      `${this.configUrl}/por-vencer/exportar?${queryParams.join('&')}`, { responseType: 'blob' }
    );
  }
  
  programar(model: IInduccionProgramarModel){
    return this.http.post<IInduccionProgramarModel>(`${this.configUrl}/programar`, model);
  }

  reprogramar(model: IInduccionReprogramarModel){
    return this.http.post<IInduccionReprogramarModel>(`${this.configUrl}/reprogramar`, model);
  }

  registrarResultados(model: InduccionResultadosModel){
    return this.http.post<InduccionResultadosModel>(`${this.configUrl}/registrar-resultados`, model);
  }
  
  getListInduccionesPorPersona(
    model: FilterInduccionesPorPersonaModel
    )    
  {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);

    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumentoIdentidad !== '') {
      queryParams.push(`nroDocumentoIdentidad=${model.nroDocumentoIdentidad}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigo=${model.codigoSolicitud}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicioInduccion){
      queryParams.push(`fechaInicioInduccion=${this.datepipe.transform(model.fechaInicioInduccion, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinInduccion){
      queryParams.push(`fechaFinInduccion=${this.datepipe.transform(model.fechaFinInduccion, 'yyyy-MM-dd')}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }
    if (model.nombreCapacitador !== '') {
      queryParams.push(`capacitador=${model.nombreCapacitador}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }
    return this.http.get<SearchResultModel<PersonaInduccionResultadoModel[]>>(
      `${this.configUrl}/personas/?${queryParams.join('&')}` 
    );
  }
}
